import { Component, OnInit, OnDestroy } from '@angular/core';
import { StorageService } from '../../services/storage.service';

@Component({
    selector: 'roadmap',
    templateUrl: './privacy-and-cookies.component.html'
})
export class PrivacyAndCookiesComponent implements OnInit, OnDestroy {
    
  roadMaps: any[] = [];
  filteredRoadMaps: any[] = [];
  filterList: any[] = [];
  allFilterIsActive: boolean = false;
  filter: any[] = [];
  completed: any[] = [];
  expected: any[] = [];
  ideas: any[] = [];

    constructor(private storageService: StorageService) {

    }

    isLoggedIn: boolean = false;

  ngOnInit() {
      this.isLoggedIn = this.storageService.getItem("token") != undefined;
      window.scrollTo(0, 0);
  }

  ngOnDestroy() {
  }

}
